var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings030(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77773 10.7C9.93753 10.7 10.8777 9.7598 10.8777 8.6C10.8777 7.4402 9.93753 6.5 8.77773 6.5C7.61794 6.5 6.67773 7.4402 6.67773 8.6C6.67773 9.7598 7.61794 10.7 8.77773 10.7Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77773 17C11.5777 14.2 14.3777 11.6928 14.3777 8.6C14.3777 5.50721 11.8705 3 8.77773 3C5.68494 3 3.17773 5.50721 3.17773 8.6C3.17773 11.6928 5.97773 14.2 8.77773 17Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings030);
export default __webpack_public_path__ + "static/media/settings-030.bc718aaf50139e64081a14157b10faad.svg";
export { ForwardRef as ReactComponent };